export default "__VITE_ASSET__655eafa1__"